import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useNavigate } from 'react-router'
import { ExternalDriverViewStore } from '../../Stores/ExternalDriverViewStore'

interface IProps {
  viewStore: ExternalDriverViewStore
}

export const ExternalDriverHeader: FC<IProps> = observer(({ viewStore }) => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const title = t('externalDrivers', 'External Drivers')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      searchInputLabel={t('searchIdNumberOrName', 'Search fID number or name')}
      breadcrumbs={breadcrumbs}
      displaySearchIcon
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => {
            viewStore.setDataToBeEdited()
            navigate(PATHS.masterData.externalDriversForm.url)
          }}
          data-cy='create-numeric-release'
        >
          {t('createExternalDriver', 'Create external driver')}
        </Button>
      }
    />
  )
})
